export default __webpack_public_path__ + "static/media/grayMedium.ec07f0d6.svg";